import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; 
import Calendar from 'react-calendar';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import 'react-calendar/dist/Calendar.css';
import './index.css';
import { useUser } from '../UserContext';
import { format } from 'date-fns';

const Agenda = () => {
  const { userInfo } = useUser();
  const navigate = useNavigate();
  const [date, setDate] = useState(new Date());
  const [agendamentos, setAgendamentos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
          AGE_STATUS: 'Agendado',
          AGE_DTA_AGENDAMENTO: '',
          AGE_MOTIVO_VISITA: '',
          AGE_OBSERVACAO: '',
          CLIENTE: '',
          FUNCIONARIO: '',
          AGE_ID: '', // isso é importante para o PUT/POST de edição
  });
  const [modoEdicao, setModoEdicao] = useState(false);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);

  // Redireciona se não estiver logado
  useEffect(() => {
    if (!userInfo?.id) {
      navigate('/');
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (userInfo?.url) {
      axios
        .get(`${userInfo.url}/agenda`)
        .then((response) => setAgendamentos(response.data))
        .catch((error) => console.error('Erro ao buscar agendamentos:', error));
    } else {
      //console.warn('URL do usuário não definida. Requisição não enviada.');
    }
  }, [userInfo]);  

  const carregarAgendamentos = () => {
    axios
      .get(`${userInfo.url}/agenda`)
      .then((response) => setAgendamentos(response.data))
      .catch((error) => console.error('Erro ao buscar agendamentos:', error));
  };  

  // Abertura e fechamento do modal
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setModoEdicao(false);
    setAgendamentoSelecionado(null);
    setFormData({
      AGE_STATUS: 'Agendado',
      AGE_DTA_AGENDAMENTO: '',
      AGE_MOTIVO_VISITA: '',
      AGE_OBSERVACAO: '',
      CLIENTE: '',
      FUNCIONARIO: '',
    });
  };  

  // Atualiza o campo do form
  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
  
    const upperCased = (type === 'text') ? value.toUpperCase() : value;
  
    setFormData(prev => ({
      ...prev,
      [name]: upperCased,
    }));
  };

  // Envia o agendamento
  const handleSubmit = (e) => {
    e.preventDefault();
  
    const endpoint = modoEdicao
      ? `${userInfo.url}/alterarAgenda`
      : `${userInfo.url}/insereagenda`;
  
    // Remove AGE_ID no modo criação
    const dadosParaEnviar = { ...formData };
    if (!modoEdicao) {
      delete dadosParaEnviar.AGE_ID;
    }
  
    axios
      .post(endpoint, dadosParaEnviar)
      .then(() => {
        alert(modoEdicao ? 'Agendamento atualizado!' : 'Agendamento realizado!');
        setFormData({
          AGE_STATUS: 'Agendado',
          AGE_DTA_AGENDAMENTO: '',
          AGE_MOTIVO_VISITA: '',
          AGE_OBSERVACAO: '',
          CLIENTE: '',
          FUNCIONARIO: '',
        });
        setShowModal(false);
        setModoEdicao(false);
        setAgendamentoSelecionado(null);
        carregarAgendamentos();
      })
      .catch((error) => console.error('Erro ao salvar agendamento:', error));
  };  

  // Estiliza dias com agendamento
  const getTileClassName = ({ date, view }) => {
    if (view === 'month') {
      const dateStr = format(date, 'yyyy-MM-dd');
      return agendamentos.some(item => item.AGE_DTA_AGENDAMENTO.startsWith(dateStr))
        ? 'has-agendamento'
        : '';
    }
    return '';
  };

  // Filtro dos agendamentos do dia selecionado
  const agendamentosDoDia = agendamentos.filter(item =>
    format(new Date(item.AGE_DTA_AGENDAMENTO), 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd')
  );

  const iniciarEdicao = (agendamento) => {
    setModoEdicao(true);
    setAgendamentoSelecionado(agendamento);
    setFormData({
      AGE_STATUS: agendamento.AGE_STATUS || 'Agendado',
      AGE_DTA_AGENDAMENTO: agendamento.AGE_DTA_AGENDAMENTO.slice(0, 16),
      AGE_MOTIVO_VISITA: agendamento.AGE_MOTIVO_VISITA,
      AGE_OBSERVACAO: agendamento.AGE_OBSERVACAO,
      CLIENTE: agendamento.CLIENTE,
      FUNCIONARIO: agendamento.FUNCIONARIO,
      AGE_ID: agendamento.AGE_ID, // Aqui está o segredo!
    });
    setShowModal(true);
  }; 
  
  return (
    <>
      <header className="header">
        <h2>Bem-vindo, {userInfo?.username || 'Usuário'}!</h2>
      </header>

      <div className="agenda-page">
        <div className="header-actions">
          <Link to="/menu" className="link-style">Voltar ao menu</Link>
          <button onClick={handleShowModal} className="btn-mais">+</button>
        </div>

        <Calendar
          onChange={setDate}
          value={date}
          tileClassName={getTileClassName}
        />

        <div className="agendamentos-list">
          <h4>Agendamentos para {format(date, 'dd/MM/yyyy')}:</h4>
          <ul>
          {agendamentosDoDia.map(item => (
            <li key={item.AGE_ID}>
              <strong>{format(new Date(item.AGE_DTA_AGENDAMENTO), 'HH:mm')}</strong> -{' '}
              <strong>({item.AGE_STATUS})</strong> - {item.AGE_MOTIVO_VISITA} - <strong>Cliente:</strong> {item.CLIENTE}<br />
              <small>{item.AGE_OBSERVACAO} </small><br />
              <small><strong>Funcionário:</strong>  {item.FUNCIONARIO} </small>
              <div>
                <Button
                  size="sm"
                  variant="outline-primary"
                  className="mt-1"
                  onClick={() => iniciarEdicao(item)}
                >
                  Editar
                </Button>
              </div>
            </li>
          ))}
          </ul>
        </div>

        <Modal show={showModal} onHide={handleCloseModal} backdrop="static" keyboard={true}>
          <Modal.Header closeButton>
            <Modal.Title>{modoEdicao ? 'Editar Agendamento' : 'Inserir Agendamento'}</Modal.Title>
          </Modal.Header>
          <Modal.Body> {agendamentoSelecionado && modoEdicao && (
                <div className="mb-3 text-muted">
                  <p><strong>Cliente:</strong> {agendamentoSelecionado.CLIENTE}</p>
                  <p><strong>Funcionário:</strong> {agendamentoSelecionado.FUNCIONARIO}</p>
                  <p><strong>Data:</strong> {format(new Date(agendamentoSelecionado.AGE_DTA_AGENDAMENTO), 'dd/MM/yyyy HH:mm')}</p>
                  <hr />
                </div>
              )}
            <Form.Group controlId="formMotivoVisita">
            <Form.Label>Selecione o Status</Form.Label>
            <Form.Control
              as="select"
              name="AGE_STATUS"
              value={formData.AGE_STATUS}
              onChange={handleInputChange}
            >
              <option value="">Selecione...</option>
              <option value="Agendado">Agendar</option>
              <option value="Em Andamento">Em Andamento</option>
              <option value="Concluído">Concluído</option>
              <option value="Cancelado">Cancelado</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formMotivoVisita">
                <Form.Label>Nome do Cliente</Form.Label>
                <Form.Control
                  type="text"
                  name="CLIENTE"
                  value={formData.CLIENTE}
                  onChange={handleInputChange}
                />
              </Form.Group>

            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formMotivoVisita">
                <Form.Label>Motivo da Visita</Form.Label>
                <Form.Control
                  type="text"
                  name="AGE_MOTIVO_VISITA"
                  value={formData.AGE_MOTIVO_VISITA}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group controlId="formObservacao">
                <Form.Label>Observação</Form.Label>
                <Form.Control
                  type="text"
                  name="AGE_OBSERVACAO"
                  value={formData.AGE_OBSERVACAO}
                  onChange={handleInputChange} 
                />
              </Form.Group>

              <Form.Group controlId="formDataAgendamento">
                <Form.Label>Data e Hora</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="AGE_DTA_AGENDAMENTO"
                  value={formData.AGE_DTA_AGENDAMENTO}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group controlId="formMotivoVisita">
                <Form.Label>Funcionario</Form.Label>
                <Form.Control
                  type="text"
                  name="FUNCIONARIO"
                  value={formData.FUNCIONARIO}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <div className="d-flex justify-content-end mt-3">
                <Button variant="secondary" onClick={handleCloseModal} className='btnEditar'>
                  Cancelar
                </Button>
                <Button variant="primary" type="submit" className="ms-2">
                  Salvar
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Agenda;